<template>
  <div
    class="common-loading"
    :class="{'is-loading': commonLoading}"
  >
    <van-loading
      :color="color"
      size="44px"
      vertical
    />
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '#ff6c02'
    }
  },
  data() {
    return {
      closeTimer: null,
      commonLoading: true,
    };
  },

  watch: {
    loading: {
      handler(newVal) {
        this.commonLoading = newVal;
        if (newVal && this.autoClose) {
          this.closeTimer = setTimeout(() => {
            this.commonLoading = false;
          }, 60000); // 一分钟自动关闭
        } else {
          clearTimeout(this.closeTimer);
        }
      },
      immediate: true,
    },
  },
  destroyed() {
    clearTimeout(this.closeTimer);
  },
};
</script>

<style scoped>
.common-loading {
  display: none;
}
.is-loading {
  position: fixed;
  top: calc(50vh - 22px);
  z-index: 9999;
  display: block;
  width: 100%;
  text-align: center;
}
</style>
